<mat-toolbar-row>
  <a mat-button routerLink="/aggregates/all" routerLinkActive="active"
    >Übersicht</a
  >
</mat-toolbar-row>
